import "./PortfolioPage.css"
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import VideoCarousel from "../../Components/VideoCarousel/VideoCarousel";
import trackPageView from "../../Utilities/trackPageView.js";
import { trackButtonClick } from "../../Utilities/trackButtonClick.js";
import { UserContext } from "../../Contexts/UserContext.js";
import { AuthContext } from "../../Contexts/AuthContext.js";
import VideoPlayer from "../../Components/VideoPlayer/VideoPlayer.js";
import {Modal, Dropdown, RadioButtons, Button, Footer} from '@nxtvid/component-library'
import { MastheadRefContext } from "../../Contexts/MastheadRefContext.js";

function PortfolioPage() {
  const { companyUrl } = useParams();
  const [listingInfo, setListingInfo] = useState(null);
  const [directorsReelVideo,setDirectorsReelVideo] = useState(null)
  const [directorsReelFileName, setDirectorsReelFileName] = useState(null)
  const [directorsReelName, setDirectorsReelName] = useState(null)
  const [aboutImg, setAboutImg] = useState(null)
  const [logo, setLogo] = useState(null)
  const [videoSrc, setVideoSrc] = useState(null);
  const [currentEventVideo, setCurrentEventVideo] = useState(0)
  const [currentProductVideo, setCurrentProductVideo] = useState(0)
  const [currentFoodAndBeverageVideo, setCurrentFoodAndBeverageVideo] = useState(0)
  const [eventVideoArray, setEventVideoArray] = useState([])
  const [productVideoArray, setProductVideoArray] = useState([])
  const [foodAndBeverageVideoArray, setFoodAndBeverageVideoArray] = useState([])
  const portfolioCategories = ['Event', 'Product', 'Food & Beverage'];
  const { userInfo, setUserInfo} = useContext(UserContext);
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
  const [RFPs, setRFPs] = useState([])
  const [selectedRadioButton, setSelectedRadioButton] = useState(null)
  const [selectedRFP, setSelectedRFP] = useState(null)
  const tokensIcon = require('../../Images/TokensIcon.png')
  const {mastheadRef} = useContext(MastheadRefContext)

  // Modal States
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalType, setModalType] = useState('confirm')
  const [modalSize, setModalSize] = useState('medium')
  const [modalTitle, setModalTitle] = useState('')
  const [modalDescription, setModalDescription] = useState('' )
  const [modalOnConfirm, setModalOnConfirm] = useState(() => () => {})
  const [modalOnCancel, setModalOnCancel] = useState(() => () => {})
  const [modalConfirmButtonText, setModalConfirmButtonText] = useState('')
  const [modalCancelButtonText, setModalCancelButtonText] = useState('')
  const [modalChildren, setModalChildren] = useState(null)
  const [modalClassName, setModalClassName] = useState('')

  // Track page view
  useEffect(() => {
    const cleanup = trackPageView(userInfo, "Portfolio Page"); // Track page view and get cleanup function

    return () => {
      cleanup(); // Call the cleanup function when the component unmounts
    };
  }, [userInfo]);

  useEffect(() => {
    if (userInfo.RFPs) {
      const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
      const uniqueRFPs = [...new Set(userInfo.RFPs)]; // Ensure unique RFPs
        console.log(uniqueRFPs)
        const fetchRFPs = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/rfp/getAllRFPs`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
                    },
                    body: JSON.stringify({ userId: userInfo._id }),
                });
                const result = await response.json();
                console.log(result.rfps)
                setRFPs(result.rfps);
            } catch (error) {
                console.error('Error fetching RFPs:', error);
            }
        }
        fetchRFPs();
    }
  }
, [userInfo]);

  // Autoplay video on load
  useEffect(() => {
    const video = document.getElementById('Portflio-Video-Player');
  
    if (video) {
      video.muted = true; // Ensure it's muted
      video.play().catch(error => console.log("Autoplay blocked:", error));
    }
  }, [videoSrc]);
  
  // Grab url and about image
  useEffect(() => {
    const fetchAboutImageUrl = async () => {
      try {
        const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
        const filePath = listingInfo.aboutImg.split('/').pop();
    
        const response = await fetch(`${API_BASE_URL}/get-logo-about-image`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
          },
          body: JSON.stringify({ filePath }),
        });
    
        const data = await response.json();
        setAboutImg(data.signedUrl);
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };
    


    
    const fetchLogoUrl = async () => {
      try {
        const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
        const filePath = listingInfo.companyLogo.split('/').pop();
    
        const response = await fetch(`${API_BASE_URL}/get-logo-about-image`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
          },
          body: JSON.stringify({ filePath }),
        });
    
        const data = await response.json();
        setLogo(data.signedUrl);
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };
    

    if (listingInfo?.aboutImg) {
      fetchAboutImageUrl();
    }
    if(listingInfo?.companyLogo){
      fetchLogoUrl();
    }
  }, [listingInfo]);

  // Fetch signed URL for director's reel
  useEffect(() => {
    console.log(`directorsReelFileName: ${directorsReelFileName}`)
    const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
    const fetchSignedUrl = async () => {
        try {
          const response = await fetch(`${API_BASE_URL}/get-signed-url-video`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({ filePath: directorsReelFileName }),
          });
          const data = await response.json();
            
            setVideoSrc(data.url);
        } catch (error) {
            console.error("Error fetching signed URL:", error);
        }
    };
    fetchSignedUrl();
}, [directorsReelFileName]);

// fetch signed urls for each type of video and store it in the respective state variable
useEffect(() => {
  const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

  const fetchSignedUrl = async (name, fileName, stateVariableSetter) => {
    console.log(`fileName for array: ${fileName}`);
    try {
      const response = await fetch(`${API_BASE_URL}/get-signed-url-video`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
        },
        body: JSON.stringify({ filePath: fileName }),
      });
      const data = await response.json();

      // Use the setter to append only if the URL does not already exist
      stateVariableSetter(prevState => {
        if (prevState.some(video => video.url === data.url)) {
          console.log(`Duplicate URL detected: ${data.url}`);
          return prevState; // Return current state without changes
        }
        return [...prevState, { fileName: name, url: data.url }];
      });

      console.log(`fileName: ${name}`);
    } catch (error) {
      console.error("Error fetching signed URL:", error);
    }
  };

  if (listingInfo?.demoReels) {
    listingInfo.demoReels.forEach((demoReel) => {
      let stateVariableSetter = null;

      if (demoReel.category === 'Event') {
        stateVariableSetter = setEventVideoArray;
      } else if (demoReel.category === 'Product') {
        stateVariableSetter = setProductVideoArray;
      } else if (demoReel.category === 'Food & Beverage') {
        stateVariableSetter = setFoodAndBeverageVideoArray;
      } else {
        return; // Skip unknown categories
      }

      fetchSignedUrl(demoReel.name, demoReel.fileName, stateVariableSetter);
    });
  }
}, [listingInfo]);

  useEffect(() => {
    setModalChildren(
      <div>
        <br/>
        <RadioButtons
          selected = {selectedRadioButton}
          setSelected = {setSelectedRadioButton} 
          radioOptions = {[
            {label: 'Create New RFP', value: 'createNewRFP'},
            {label: 
              <div>
                <div className="select-existing-RFP-label">Select Existing RFP
                  <div className = 'submit-rfp-tokens-container'><img alt="tokens" className='submit-rfp-tokens' src={tokensIcon}/>~5</div>
                </div>
                
                <Dropdown selected = {selectedRFP} setSelected={(value) => setSelectedRFP(value)} border placeholder='Select an RFP' dropdownOptions = {RFPs.map(RFP =>{return RFP.title})}/>
              </div>
              , value: 'selectExistingRFP'}
          ]}
        />
        <br/>
        <Button type='primary' size='large' label = 'Submit' onClick = {handleSelectRFPMethod}/>
      </div>
    )
  },[selectedRFP, selectedRadioButton])
  
  const handleSubmitRFP = () => {
    setIsModalOpen(true)
    setModalType('empty')
    setModalSize('medium')
    setModalTitle('Submit RFP')
    setModalDescription(`Select an RFP to submit to ${listingInfo.companyName} or create a new one.`)
    setModalClassName('submit-rfp-modal')
    setModalChildren(
    <div>
      <br/>
      <RadioButtons
        selected = {selectedRadioButton}
        setSelected = {setSelectedRadioButton} 
        radioOptions = {[
          {label: 'Create New RFP', value: 'createNewRFP'},
          {label: 
            <div>
              <div className="select-existing-RFP-label">Select Existing RFP
                  <div className = 'submit-rfp-tokens-container'><img alt="tokens" className='submit-rfp-tokens' src={tokensIcon}/>~5</div>
                </div>
              <Dropdown selected = {selectedRFP} setSelected={(value) => setSelectedRFP(value)} border placeholder='Select an RFP' dropdownOptions = {RFPs.map(RFP =>{return RFP.title})}/>
            </div>
            , value: 'selectExistingRFP'}
        ]}
      />
      <br/>
      <Button type='primary' size='large' label = 'Submit' onClick = {handleSelectRFPMethod}/>
    </div>
  )
  setModalOnCancel(() =>()=> {
    setIsModalOpen(false)
  })

    trackButtonClick("Submit RFP", userInfo, "Submit RFP", "Primary");
    function replaceSpacesWithPlus(str) {
      return str.replace(/ /g, '+');
  }
  /* console.log('User Info:', userInfo);

    if (isAuthenticated){
      window.open(`https://docs.google.com/forms/d/e/1FAIpQLSd974CfQ12cuXgZkmcpuzu0w8JpPVCdyKYtiIsC0BtZYUiRsg/viewform?usp=pp_url&entry.986882268=${replaceSpacesWithPlus(userInfo.company)}&entry.1279552351=${replaceSpacesWithPlus(userInfo.firstName + " " + userInfo.lastName)}&entry.1521452447=${userInfo.email}&entry.2124870306=${replaceSpacesWithPlus(listingInfo.companyName)}`, '_blank');
    }
    else{
      window.open(`https://docs.google.com/forms/d/e/1FAIpQLSd974CfQ12cuXgZkmcpuzu0w8JpPVCdyKYtiIsC0BtZYUiRsg/viewform?usp=pp_url&entry.2124870306=${replaceSpacesWithPlus(listingInfo.companyName)}`, '_blank');
    }  */ 
      
    };
  
    const handleSelectRFPMethod = async () => {
     if (selectedRadioButton === 'createNewRFP'){
      window.open('https://app.nxtvid.io/RFPBuilder', '_blank')
      setIsModalOpen(false)
     }
      else if (selectedRadioButton === 'selectExistingRFP'){
        console.log(`Selected RFP: ${selectedRFP}`)
        const selectedRFPInfo = RFPs.find(RFP => RFP.title === selectedRFP);
        
        // check tokens

        try {
          const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
          const response = await fetch(`${API_BASE_URL}/validate-token-amount`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({ userInfo:userInfo, amount: 5 }),
          });
          const result = await response.json();
          if(result.message === "Not Enough Tokens"){
            setIsModalOpen(false);
            mastheadRef.current?.triggerTokenModal()
            return
          }
          else if(result.message === "No User Found"){
            setIsModalOpen(true)
            setModalType('alert')
            setModalSize('medium')
            setModalTitle('Error')
            setModalDescription(`You must be signed in to submit an RFP. Please sign in and try again.`)
            setModalClassName('')
            setModalChildren(null)
            setModalOnConfirm(() =>()=> {
              setIsModalOpen(false)
            })
            setModalOnCancel(() =>()=> {
              setIsModalOpen(false)
            })
            setModalConfirmButtonText('OK')
            setModalCancelButtonText('')
            return;
          }
        } catch (error) {
          setIsModalOpen(true)
            setModalType('alert')
            setModalSize('medium')
            setModalTitle('Error')
            setModalDescription(`There was an error submitting your RFP. Please try again in a few minutes.`)
            setModalClassName('')
            setModalChildren(null)
            setModalOnConfirm(() =>()=> {
              setIsModalOpen(false)
            })
            setModalOnCancel(() =>()=> {
              setIsModalOpen(false)
            })
            setModalConfirmButtonText('OK')
            setModalCancelButtonText('')
            return;
        }
        


        // send email
        try {
          const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
          const response = await fetch(`${API_BASE_URL}/api/rfp/sendRFPToVideographer`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({ userInfo:userInfo, listingInfo:listingInfo, rfpId:selectedRFPInfo._id }),
          });
          const result = await response.json();
          if (result.status === 400 || result.status === 404 || result.status === 500) {
            setIsModalOpen(true)
            setModalType('alert')
            setModalSize('medium')
            setModalTitle('Error')
            setModalDescription(`There was an error submitting your RFP. Please try again in a few minutes.`)
            setModalClassName('')
            setModalChildren(null)
            setModalOnConfirm(() =>()=> {
              setIsModalOpen(false)
            })
            setModalOnCancel(() =>()=> {
              setIsModalOpen(false)
            })
            setModalConfirmButtonText('OK')
            setModalCancelButtonText('')
            return;
          }

  
        } catch (error) {
            setIsModalOpen(true)
            setModalType('alert')
            setModalSize('medium')
            setModalTitle('Error')
            setModalDescription(`There was an error submitting your RFP. Please try again in a few minutes.`)
            setModalClassName('')
            setModalChildren(null)
            setModalOnConfirm(() =>()=> {
              setIsModalOpen(false)
            })
            setModalOnCancel(() =>()=> {
              setIsModalOpen(false)
            })
            setModalConfirmButtonText('OK')
            setModalCancelButtonText('')
            return;
        }

        // reduce tokens
        try {
          const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
          const response = await fetch(`${API_BASE_URL}/reduceTokens`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({ userInfo:userInfo, amount: 5 }),
          });
          const result = await response.json();
          if (result.status === 400 || result.status === 404 || result.status === 500) {
            console.log("something went wrong");
          }
          const updatedUserInfo = { ...userInfo, tokens: userInfo.tokens - 5 };
          setUserInfo(updatedUserInfo);
        } catch (error) {
          console.log("something went wrong", error);
        }

        setIsModalOpen(true)
            setModalType('alert')
            setModalSize('medium')
            setModalTitle('RFP Submitted')
            setModalDescription(`Your RFP has been submitted to ${listingInfo.companyName}.`)
            setModalClassName('')
            setModalChildren(null)
            setModalOnConfirm(() =>()=> {
              setIsModalOpen(false)
            })
            setModalOnCancel(() =>()=> {
              setIsModalOpen(false)
            })
            setModalConfirmButtonText('OK')
            setModalCancelButtonText('')
      }
    }
  
  const getListingInfo = async() =>{
    try {
        const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
        const response = await fetch(`${API_BASE_URL}/api/getListingInfoFromUrl`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
          },
          body: JSON.stringify({ companyUrl: companyUrl }),
        });
        const result = await response.json();
        if (result.status === 400 ) {
          console.log(result.status.message);
          return;
        }
        setListingInfo(result);
        
      } catch (error) {
        console.log("something went wrong", error);
      }
  }

  const LocationsList = () =>{
    let locationsList = []
    listingInfo.location.map((location=>{
      locationsList.push(
        <div className="location-tag">
          <p>{location}</p>
        </div>
      )
    }))
    return <div className="location-list">{locationsList}</div>
  }

  
  useEffect(() => {
    if (companyUrl) {
        getListingInfo();
      }
  }, [companyUrl]);

  useEffect(()=>{
    if(listingInfo && listingInfo.demoReels[0]){
      listingInfo.demoReels.map((demoReel, index)=>{
        if (demoReel.category === `Director's Reel`){
          console.log(`directorsReelVideo: ${directorsReelVideo}`)
          let fileName = listingInfo.demoReels[index].fileName;
          let name = listingInfo.demoReels[index].name;
          setDirectorsReelFileName(fileName)
          setDirectorsReelName(name)
          setDirectorsReelVideo(`https://storage.cloud.google.com/nxtvid_marketplace_listing_videos/${fileName}`)
        }
      })
        
    }
    
  }, [listingInfo])


  if (!listingInfo) return <div>Loading...</div>;

  
  const ClientList = () =>{
    let clientList = []
    listingInfo.clients.map(client=>{
      clientList.push(<div className='client'>{client}</div>)
    })
    return (<div className='client-list'>{clientList}</div>)
  }

  const PackageDetails = ({packageDetails}) =>{
    let detailElements = []
    packageDetails.map(detail=>{
      detailElements.push(<li>{detail}</li>)
    })
    return(
      <div className="package-details">
        <ul className="details-list">
          {detailElements}
        </ul>
      </div>
    )
  }

  

  const VideoCarouselSection = ({
    portfolioCategories,
    eventVideoArray,
    productVideoArray,
    foodAndBeverageVideoArray,
    currentEventVideo,
    setCurrentEventVideo,
    currentProductVideo,
    setCurrentProductVideo,
    currentFoodAndBeverageVideo,
    setCurrentFoodAndBeverageVideo
  }) => {
    const getDefaultCategory = () => {
      if (eventVideoArray.length > 0) return 'Event';
      if (productVideoArray.length > 0) return 'Product';
      if (foodAndBeverageVideoArray.length > 0) return 'Food & Beverage';
      return portfolioCategories[0] || '';
    };
  
    const [currentCategory, setCurrentCategory] = useState(getDefaultCategory);
  
    const getCarouselProps = (category) => {
      switch (category) {
        case 'Event':
          return { 
            arrayOfVideoUrls: eventVideoArray, 
            currentVideo: currentEventVideo, 
            setCurrentVideo: setCurrentEventVideo 
          };
        case 'Product':
          return { 
            arrayOfVideoUrls: productVideoArray, 
            currentVideo: currentProductVideo, 
            setCurrentVideo: setCurrentProductVideo 
          };
        case 'Food & Beverage':
          return { 
            arrayOfVideoUrls: foodAndBeverageVideoArray, 
            currentVideo: currentFoodAndBeverageVideo, 
            setCurrentVideo: setCurrentFoodAndBeverageVideo 
          };
        default:
          return null;
      }
    };
  
    // Compute carouselProps once for consistency
    const carouselProps = getCarouselProps(currentCategory);
  
    return (
      <div className="Video-Carousel-Container">
        <div className="demo-reel-headers">
          {portfolioCategories.map((category, index) => {
            if (category === 'Event' && eventVideoArray.length === 0) return null;
            if (category === 'Product' && productVideoArray.length === 0) return null;
            if (category === 'Food & Beverage' && foodAndBeverageVideoArray.length === 0) return null;
  
            return (
              <h3 
                key={index} 
                className={`demo-reel-header ${currentCategory === category ? 'active' : ''}`}
                onClick={() => {
                  setCurrentCategory(category);
                  // Reset the appropriate video's index when switching categories
                  if (category === 'Event') setCurrentEventVideo(0);
                  else if (category === 'Product') setCurrentProductVideo(0);
                  else if (category === 'Food & Beverage') setCurrentFoodAndBeverageVideo(0);
                }}
              >
                {category} Work
              </h3>
            );
          })}
        </div>
        <div className="Video-Carousel-Wrapper">
          {carouselProps?.arrayOfVideoUrls.length > 0 &&
            <VideoCarousel 
              {...carouselProps}
            />
          }
        </div>
      </div>
    );
  };
  
  
  
  
  
  
  
  return (
    <div>
      <div className="App-body-porfolio">
      <div className="background-shades" onClick={(e)=>{e.target.style.display='none'; document.getElementsByClassName("sign-in-card")[0].style.display='none'; document.getElementsByClassName("sign-up-card")[0].style.display='none'; document.getElementsByClassName("forgot-password-card")[0].style.display='none';document.getElementsByClassName("purchase-tokens-card")[0].style.display='none'; document.getElementsByClassName('sign-in-notification-message')[0].innerHTML=''; document.getElementsByClassName('sign-up-notification-message')[0].innerHTML=''; }}/>
        {isModalOpen ? <Modal className={modalClassName} children={modalChildren} type={modalType} title={modalTitle} description={modalDescription} onConfirm={modalOnConfirm} onClose={modalOnCancel} confirm_button_text={modalConfirmButtonText} cancel_button_text={modalCancelButtonText}/> : null}
        <div className="background-shades" onClick={(e)=>{e.target.style.display='none'; document.getElementsByClassName("sign-in-card")[0].style.display='none'; document.getElementsByClassName("sign-up-card")[0].style.display='none'; document.getElementsByClassName("forgot-password-card")[0].style.display='none';document.getElementsByClassName("purchase-tokens-card")[0].style.display='none'; document.getElementsByClassName('sign-in-notification-message')[0].innerHTML=''; document.getElementsByClassName('sign-up-notification-message')[0].innerHTML=''; }}/>
        <div className="portfolio-card-1">
        <VideoPlayer videoSrc={videoSrc} id='Portflio-Video-Player' className='portfolio-video-player' autoplay muted/>
        <h3 className="Video-Title">{ listingInfo && directorsReelFileName ? `${listingInfo.companyName} | ${directorsReelName}` : ``}</h3>   
        </div>
        <div className="Company-Info">
            <div className="Company-Logo">
              <img className='logo-img' alt={`${listingInfo.companyName}'s Logo`} src={logo} onClick={()=>console.log(listingInfo)}/>
            </div>
            <div className="Company-Name">
                <h2>{listingInfo.companyName}</h2>
                <LocationsList/>
            </div>
            <Button className='submit-rfp-button' label='Submit RFP' onClick={handleSubmitRFP}/>
            <div className="submit-rfp-button-mobile">
              <p>...</p>
              <div className="submit-rfp-button-mobile-dropdown">
                <p onClick={handleSubmitRFP}>Submit RFP</p>
              </div>
              </div>
        </div>
        <div className="portfolio-card-2">          
            <div className="about-image">
              <img  alt={`The Videography Company, ${listingInfo.companyName}, in action.`} src={aboutImg}/>
            </div>
            <div className="about-card">
            <h3 className="about-header">About</h3>
            <p className="about-text">{listingInfo.about}</p>
          </div>       
        </div>
        <VideoCarouselSection portfolioCategories={portfolioCategories} eventVideoArray={eventVideoArray} productVideoArray={productVideoArray} foodAndBeverageVideoArray={foodAndBeverageVideoArray} currentEventVideo={currentEventVideo} currentProductVideo={currentProductVideo} currentFoodAndBeverageVideo={currentFoodAndBeverageVideo} setCurrentEventVideo={setCurrentEventVideo} setCurrentProductVideo={setCurrentProductVideo} setCurrentFoodAndBeverageVideo={setCurrentFoodAndBeverageVideo}/>
        <div className={`pricing-section ${listingInfo.packagesVisible ? '' : 'hidden'}`}>
          <h3 className="pricing-header">Pricing</h3>
          <p className="pricing-disclaimer"><i>
          <b>Disclaimer: </b>
          All pricing is illustrative and subject to negotiation. Final costs may vary based on location, project dates, and scope of work. Please submit a content request form to discuss your specific needs and receive a customized quote.
          </i>
          </p>
          <div className='pricing-options'>
          <div className='pricing-option'>
            <h3 className="package-name">{listingInfo.packages[0].packageName}</h3>
            <h4 className="package-cost">${listingInfo.packages[0].packageCost}</h4>
            <div className="details-section">
              <h5 className="package-description">{listingInfo.packages[0].packageDescription}</h5>
              <PackageDetails packageDetails = {listingInfo.packages[0].packageDetails}/>
            </div>
          </div>
          <div className='pricing-option'>
          <h3 className="package-name">{listingInfo.packages[1].packageName}</h3>
          <h4 className="package-cost">${listingInfo.packages[1].packageCost}</h4>
          <div className="details-section">
              <h5 className="package-description">{listingInfo.packages[1].packageDescription}</h5>
              <PackageDetails packageDetails = {listingInfo.packages[1].packageDetails}/>
            </div>
          </div>
          <div className='pricing-option'>
          <h3 className="package-name">{listingInfo.packages[2].packageName}</h3>
          <h4 className="package-cost">${listingInfo.packages[2].packageCost}</h4>
          <div className="details-section">
              <h5 className="package-description">{listingInfo.packages[2].packageDescription}</h5>
              <PackageDetails packageDetails = {listingInfo.packages[2].packageDetails}/>
            </div>
          
          </div>
          </div>
          
        </div>
        <div className='portfolio-card-3'>
          <h3 className="clients-header">Clients</h3>
          <ClientList />
        </div>
      </div>
      <footer>
                <Footer/>
        </footer> 
    </div>
  );
}

export default PortfolioPage;
